import { render, staticRenderFns } from "./Blog.vue?vue&type=template&id=1addf25f&scoped=true"
import script from "./Blog.vue?vue&type=script&lang=js"
export * from "./Blog.vue?vue&type=script&lang=js"
import style0 from "./Blog.vue?vue&type=style&index=0&id=1addf25f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1addf25f",
  null
  
)

export default component.exports